export enum TABLE_ROW_STATE {
  EXPANDED = 'expanded',
  COLLAPSED = 'collapsed'
}

export declare type TableRowState = 'expanded' | 'collapsed';
